module.exports = __webpack_public_path__ + "static/media/blue-wave-bottom.3526bde5.svg";